import './slots-grid.scss'
